import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ForgotPasswordService } from '../../service/forgot-password.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifs-password-reset-form',
    templateUrl: './password-reset-form.component.html',
    styleUrls: ['./password-reset-form.component.scss'],
    standalone: false
})
export class PasswordResetFormComponent implements OnInit {
  token: string;
  loading: boolean
  form: UntypedFormGroup;

  constructor(
    private route: ActivatedRoute,
    private forgotPasswordService: ForgotPasswordService,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      newPassword: ['', Validators.compose([Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/)])],
      confirmPassword: ['', Validators.required]
    }, { validator: formPasswordConfirmationValidator('newPassword', 'confirmPassword') });
  }

  ngOnInit(): void {
    this.loading = false;
    this.route.queryParams.pipe(untilDestroyed(this))
    .subscribe(params => {
      this.token = params['token'];
    });
  }

  submit(): void {
    if (!this.form.valid) return;
    this.loading = true;
    this.forgotPasswordService.submit({
      token: this.token,
      password: this.form.get('newPassword').value,
      confirmPassword: this.form.get('confirmPassword').value
    })
    .pipe(untilDestroyed(this))
      .subscribe(() => this.loading = false);
  }
}

function formPasswordConfirmationValidator(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors) {
      return;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
